import React from 'react'
import { Link } from "react-router-dom";


const Physiotherapy = () => {
    return (
        <>
            <div className="dz-bnr-inr dz-banner-dark overlay-secondary-middle dz-bnr-inr-md" style={{ background: "url(./assets/img/Hospital.jpg)" }}>
                <div className="container">
                    <div className="dz-bnr-inr-entry d-table-cell">
                        <h1 className="" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp', color: "white" }}>फिजियोथेरेपी</h1>
                        <nav aria-label="breadcrumb" className="breadcrumb-row wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <ul className="">
                                <li className="breadcrumb-item"><Link to="/">होम</Link></li>
                                <li className="breadcrumb-item">फिजियोथेरेपी</li>
                            </ul>
                        </nav>
                        <div className="dz-btn">
                            <a to="tel:+91 9165155945" className="btn btn-lg btn-icon btn-primary radius-xl btn-shadow mb-3 mb-sm-0">
                                <span className="left-icon">
                                    <i className="feather icon-phone-call" />
                                </span>
                                +91 9165155945
                            </a>
                        </div>
                    </div>
                </div>
                <span className="text-vertical">24/7 आपातकालीन सेवा</span>
                <ul className="dz-social">
                    <li>
                        <Link to="https://www.facebook.com/p/Omkar-Multispeciality-Hospital-61578676481836/" target="_blank">
                            <i className="fa-brands fa-facebook-f" />
                        </Link>
                    </li>
                    <li>
                        <a to="https://www.instagram.com" target="_blank">
                            <i className="fa-brands fa-instagram" />
                        </a>
                    </li>

                    <li>
                        <a to="https://twitter.com" target="_blank">
                            <i className="fa-brands fa-x-twitter" />
                        </a>
                    </li>
                    <li>
                        <a to="https://www.youtube.com" target="_blank">
                            <i className="fa-brands fa-youtube" />
                        </a>
                    </li>
                </ul>
            </div>

            <section className="content-inner" style={{ marginTop: "-10px" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                            <div className="dz-team style-1 box-hover">
                                <div className="dz-media">
                                    <img src="./assets/img/Physiotherapy_01.webp" alt="/" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                            <div className="dz-team style-1 box-hover">
                                <div className="dz-media">
                                    <img src="./assets/img/Physiotherapy_02.webp" alt="/" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                            <div className="dz-team style-1 box-hover">
                                <div className="dz-media">
                                    <img src="./assets/img/Physiotherapy_03.webp" alt="/" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                            <div className="dz-team style-1 box-hover">
                                <div className="dz-media">
                                    <img src="./assets/img/Physiotherapy_04.webp" alt="/" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="content-inner service-single">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 single-inner order-lg-1">
                            <div className="single-media dz-media single-media height-sm radius-lg wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.1s', animationName: 'fadeInUp' }}>
                                <img src="./assets/img/Physiotherapy_1.webp" alt className="object-fit-cover" />
                            </div>
                            <div className="content-item wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                                <h2>फिजियोथेरेपी</h2>
                                <p>
                                    फिजियोथेरेपी डिपार्टमेंट में, हम अपने मरीज़ों की मूवमेंट को ठीक करने, दर्द कम करने और उनकी ज़िंदगी की पूरी क्वालिटी को बेहतर बनाने के लिए पूरी तरह तैयार हैं। हमारा डिपार्टमेंट सभी उम्र के लोगों को पूरी रिहैबिलिटेशन सर्विस देता है, जिससे उन्हें चोट, सर्जरी या पुरानी बीमारियों से उबरने में मदद मिलती है।

                                    हमारी बहुत काबिल और अनुभवी फिजियोथेरेपिस्ट की टीम हर मरीज़ की ज़रूरतों के हिसाब से पर्सनलाइज़्ड ट्रीटमेंट प्लान देने के लिए सबूतों पर आधारित तकनीकों और एडवांस्ड इक्विपमेंट का इस्तेमाल करती है। हम न सिर्फ़ रिकवरी पर बल्कि बचाव और लंबे समय तक सेहत पर भी ध्यान देते हैं।
                                </p>
                            </div>
                            <div className="content-item wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.3s', animationName: 'fadeInUp' }}>
                                <h3>हम इन स्थितियों का इलाज करते हैं</h3>
                                <ul className="text-secondary grid-2 m-b30">
                                    <li>  ✅   पेन मैनेजमेंट थेरेपी</li>
                                    <li>  ✅  सर्जिकल रिहैबिलिटेशन के बाद </li>
                                    <li>  ✅   ऑर्थोपेडिक और स्पोर्ट्स इंजरी रिहैबिलिटेशन</li>
                                    <li>  ✅   न्यूरोलॉजिकल फिजियोथेरेपी</li>
                                    <li>  ✅   पीडियाट्रिक फिजियोथेरेपी</li>
                                    <li>  ✅  जेरियाट्रिक फिजियोथेरेपी </li>
                                    <li>  ✅   एक्सरसाइज थेरेपी और मैनुअल थेरेपी</li>
                                    <li>  ✅   इलेक्ट्रोथेरेपी ट्रीटमेंट</li>
                                </ul>
                            </div>

                            <div className="content-item wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.3s', animationName: 'fadeInUp' }}>
                                <h3>फिजियोथेरेपी से किन बीमारियों का इलाज होता है?</h3>
                                <ul className="text-secondary grid-2 m-b30">
                                    <li>  ✅ पीठ दर्द और गर्दन दर्द</li>
                                    <li>  ✅ जोड़ों का दर्द (घुटने, कंधे, कूल्हे)</li>
                                    <li>  ✅ खेल-कूद से लगी चोटें</li>
                                    <li>  ✅ लकवा और स्ट्रोक से उबरना</li>
                                    <li>  ✅ गठिया (Arthritis)</li>
                                    <li>  ✅ मांसपेशियों में अकड़न</li>
                                    <li>  ✅ सर्जरी के बाद ठीक होने की प्रक्रिया (Rehabilitation)</li>
                                    <li>  ✅ न्यूरोलॉजिकल विकार (तंत्रिका तंत्र से जुड़ी समस्याएं)</li>
                                </ul>
                                <b style={{ color: "black" }}>🏥 फिजियोथेरेपी इलाज के प्रकार</b>
                                <ul className="text-secondary grid-2 m-b30">
                                    <li>  ✅ व्यायाम थेरेपी (ताकत और लचीलेपन के लिए)</li>
                                    <li>  ✅ मैनुअल थेरेपी (हाथों से किया जाने वाला इलाज)</li>
                                    <li>  ✅ इलेक्ट्रोथेरेपी (TENS, IFT)</li>
                                    <li>  ✅ गर्म और ठंडी थेरेपी </li>
                                    <li>  ✅  अल्ट्रासाउंड थेरेपी</li>
                                    <li>  ✅  हाइड्रोथेरेपी (पानी से किया जाने वाला इलाज)</li>
                                    <li>  ✅  मालिश थेरेपी</li>
                                </ul>
                                <b style={{ color: "black" }}>🌟 फिजियोथेरेपी के फायदे</b>
                                <ul className="text-secondary grid-2 m-b30">
                                    <li>  ✅ बिना दवा के दर्द से राहत</li>
                                    <li>  ✅ चोट या सर्जरी के बाद तेजी से ठीक होना</li>
                                    <li>  ✅ चलने-फिरने की क्षमता और लचीलेपन में सुधार</li>
                                    <li>  ✅ मांसपेशियों और जोड़ों को मजबूत बनाना</li>
                                    <li>  ✅भविष्य में होने वाली चोटों से बचाव </li>
                                    <li>  ✅ शरीर की मुद्रा (Posture) और संतुलन में सुधार</li>
                                </ul>

                            </div>
                        </div>
                        <div className="col-lg-4 m-b30">
                            <aside className="side-bar sticky-top left">
                                <div className="widget service_menu_nav bg-secondary wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.7s" style={{ visibility: 'visible', animationDuration: '0.7s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                                    <div className="widget-title">
                                        <h4 className="title">सभी सेवाएँ</h4>
                                    </div>
                                    <ul>
                                        <li className="active" ><Link to="/physiotherapy">फिजियोथेरेपी</Link></li>
                                        <li><Link to="/urology">अनेस्थिसियोलॉजी</Link></li>
                                        <li><Link to="/urology">यूरोलॉजी</Link></li>
                                        <li ><Link to="/dermatology">त्वचा विशेषज्ञ</Link></li>
                                        <li><Link to="/pulmonology">पल्मोनोलॉजी</Link></li>
                                        <li><Link to="/ent">कान, नाक और गले</Link></li>
                                        <li><Link to="/paediatrics">बाल चिकित्सा</Link></li>
                                        <li><Link to="/gynaecology">प्रसूति एवं स्त्री रोग</Link></li>
                                        <li ><Link to="/dental">डेंटल</Link></li>
                                        <li><Link to="/general-medicine">सामान्य दवा</Link></li>
                                        <li><Link to="/general-surgery">जनरल सर्जरी</Link></li>
                                        <li><Link to="/orthopedic">ऑर्थोपेडिक</Link></li>
                                        <li><Link to="/anaesthesiology">एनेस्थिसियोलॉजी</Link></li>
                                        <li><Link to="/general-medicine">जनरल मेडिसिन</Link></li>
                                    </ul>
                                </div>
                                <div className="widget_contact" style={{ backgroundImage: 'url(./assets/images/background/bg3.png)' }} data-wow-delay="0.4s" data-wow-duration="0.7s">
                                    <div className="widget-content">
                                        <img src="./assets/images/question.png" width={80} alt />
                                        <h4 className="title">क्या आपको किसी मदद की ज़रूरत है?</h4>
                                        <div className="phone-number">
                                            <a href="tel:+919165155945">+91 9165155945</a>
                                        </div>
                                        <div className="email">
                                            <a href="mailto:omkarmultispecialityhospital1@gmail.com">omkarmultispecialityhospital1
                                                @gmail.com</a>
                                        </div>
                                        <div className="link-btn">
                                            <a to="/contact-us" className="btn btn-lg btn-icon btn-white hover-secondary btn-shadow">
                                                Contact Us <span className="right-icon"><i className="feather icon-arrow-right" /></span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </aside>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default Physiotherapy